import { getServerBaseUrl } from "./backend";

/**
 * Returns GraphQL endpoint derived from the current chain server base.
 * Example local: http://localhost:3333/graphql
 */
export function getGraphqlUrl(chainId: number) {
  return `${getServerBaseUrl(chainId)}graphql`;
}
